import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MediaTypes } from '../../enums/media-types';
import { ImgOrVideo } from '../../types/media-type';

@Component({
  selector: 'app-media-adder-item',
  templateUrl: './media-adder-item.component.html',
  styleUrls: ['./media-adder-item.component.scss'],
})
export class MediaAdderItemComponent {
  @Input() sectionFormControl: FormControl;
  @Input() mediaType: `${MediaTypes}`;
  @Input() cssIconClass: string;
  @Input() addMediaLabel: string;
  @Input() isMainMedia: boolean;
  @Input() isSlide?: boolean = false;
  @Input() isDisabled: boolean;
  @Output() handleInsertMedia = new EventEmitter<ImgOrVideo>();
  @Output() handleRemoveMedia = new EventEmitter<{
    mediaToRemove: ImgOrVideo;
    mediaIndexToRemove: number;
  }>();
  @Output() handleAddMedia = new EventEmitter<`${MediaTypes}`>();

  @ContentChild(TemplateRef) templateOutlet!: TemplateRef<any>;

  MEDIA_TYPES = MediaTypes;
  imageCaptureControl: FormControl<string>;
}
